export enum ECompanionMode {
  Simultaneous = 0,
  React = 1,
  Agility = 2,
}


